"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isProperSqon = function isProperSqon(sqon) {
  return !!(sqon && sqon.op);
};

var _default = function _default(_ref) {
  var clientSideFilter = _ref.clientSideFilter,
      serverSideFilter = _ref.serverSideFilter;
  return {
    op: 'and',
    content: [isProperSqon(clientSideFilter) ? clientSideFilter : {
      op: 'and',
      content: []
    }, serverSideFilter || {
      op: 'and',
      content: []
    }]
  };
};

exports["default"] = _default;